import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from 'react-hook-form';
import { Button } from "primereact/button";
import { InputSwitch } from 'primereact/inputswitch';
import { SetStateAction, useEffect, useState } from "react";
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from "primereact/tree";
import { Dropdown } from 'primereact/dropdown';
import getPermissaoUser from "../../service/getPermissaoUser";
import { carregarFranquias } from "../../hooks/useFranquias";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";

export default function PerfilCadastrar({ perfil, onClose, onSave }: { perfil: any, onClose: () => void, onSave: (perfil: any) => void }) {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const [inativo, setInativo] = useState(perfil.inativo ? perfil.inativo : false);
  const [nodes, setNodes] = useState<any[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null);
  const [franquias, setFranquias] = useState<any>([]);
  const idsPermissoes: any[] = [];

  const defaultValues = {
    descricao: '',
    franquia: null as any
  };
  defaultValues.descricao = perfil.descricao ? perfil.descricao.toString() : ''

  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit
  } = useForm({ defaultValues });

  const onSubmit = (data: any) => {
    data.descricao && save(data);
  };

  const save = (data: any) => {
    const permissoes: any[] = [];
    if (selectedKeys) {
      Object.getOwnPropertyNames(selectedKeys).map((item) => permissoes.push({ id: item }));
    }
    const perfilSalvar = {
      id: perfil.id ? perfil.id : undefined,
      descricao: data.descricao.trim(),
      inativo: inativo,
      idFranquia: data.franquia?.id ?? null,
      permissoes: permissoes
    }
    window.scrollTo(0, 0);
    onSave(perfilSalvar);
  }

  const getFormErrorMessage = (name: string) => {
    type ObjectKey = keyof typeof errors;
    const error = errors[Object.keys(errors).find(k => k === name) as ObjectKey]
    return error ? <small className="p-error">{error.message as string}</small> : <small className="p-error">&nbsp;</small>;
  };

  const ordenarPorLabel = (lista: any[]) => {
    lista.sort((s1: { label: string }, s2: { label: string }) => {
      const nameA = s1.label.toUpperCase();
      const nameB = s2.label.toUpperCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  }

  const createPermissoes = () => {
    const option: any[] = [];
    getPermissaoUser().then(data => {
      ordenarPorLabel(data);
      data.forEach((element: { label: string; id: string; composicaoConsulta: string; permissoes: any[] }) => {
        verifyChecked(element);
        option.push({ label: element.label, composicaoConsulta: element.composicaoConsulta, key: element.id, Collapse: true, children: createPermissoesFilhos(element.permissoes) });
      });
      setNodes([...option]);
    })
    return option;
  }

  const createPermissoesFilhos = (permissoes: any[]) => {
    const option: any[] = [];
    if (permissoes) {
      ordenarPorLabel(permissoes);
      permissoes.forEach((element: { label: string; id: string; composicaoConsulta: string; permissoes: any[] }) => {
        verifyChecked(element);
        option.push({ label: element.label, composicaoConsulta: element.composicaoConsulta, key: element.id, Collapse: true, children: createPermissoesFilhos(element.permissoes) });
      });
    }
    return option;
  }

  const nodeTemplate = (node: any) => {
    return (
      <div>
        <span style={{ fontWeight: 'bold' }}>{node.label}</span>
        {node.composicaoConsulta && (
          <div style={{ fontSize: '0.8rem', fontWeight: 'normal', color: '#6c757d' }}>{node.composicaoConsulta}</div>
        )}
      </div>
    );
  };

  const verifyChecked = (element: any) => {
    if (perfil.permissoes) {
      const checked = perfil.permissoes.find((k: { value: any; }) => k.value === element.value);
      if (checked) {
        idsPermissoes.push(element.id)
        const selectedKeysChecked: SetStateAction<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null> = {}
        idsPermissoes.forEach(id => {
          selectedKeysChecked[id] = {
            partialChecked: false,
            checked: true
          }
        });
        setSelectedKeys(selectedKeysChecked);
      }
    }
  }

  useEffect(() => {
    setNodes(createPermissoes());
    carregarFranquias().then(lista => {
      lista.forEach((c: { nome: string; id: string; }) => {
        if (perfil.id && perfil.idFranquia && c.nome === perfil.nomeFranquia) {
          setValue('franquia', c)
        }
        if (state.user.franquiaSelected && c.nome === state.user.franquiaSelected.nome) {
          setValue('franquia', c)
        }
      })
      setFranquias(lista);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
        <div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <Controller
                name="descricao"
                control={control}
                rules={{ required: 'Descrição é Obrigatória' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="">
                      <div>
                        <label htmlFor="descricao" className="font-bold block mb-2 required">{t('descricao')} </label>
                        <InputText style={{ width: '100%' }} id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                      </div>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="col">
              {!state.user.franquia && (
                <Controller
                  name="franquia"
                  control={control}
                  render={({ field }) => (
                    <div>
                      <label htmlFor={field.name} className="font-bold block mb-2">{t('franquia')}</label>
                      <Dropdown disabled={state.user.franquiaSelected} style={{ width: '100%' }} id={field.name} value={field.value} onChange={(e) => field.onChange(e.value)} options={franquias} optionLabel="nome"
                        filter showClear placeholder="Selecione" className="w-full md:w-14rem" />
                    </div>
                  )}
                />
              )}
            </div>
          </div>
          <div className="grid">
            <div className="col p-fluid flex flex-wrap">
              <div>
                <label className="label-dados" style={{ paddingLeft: '0' }}>{t('inativo')}</label>
                <div style={{ width: '100%' }}>
                  <InputSwitch checked={inativo} value={inativo} onChange={() => setInativo(!inativo)} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <label className="font-bold block mb-2">{t('permissoes')}</label>
        <Tree expandIcon={undefined} collapseIcon={undefined} value={nodes} nodeTemplate={nodeTemplate} selectionMode="checkbox" selectionKeys={selectedKeys} onSelectionChange={(e) => setSelectedKeys(e.value)} />
        <br></br>
        <br></br>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "1rem" }} className=" flex">
          <Button style={{ marginRight: "1rem", backgroundColor: '#183462' }} label={t('salvar') as string} type="submit" />
          <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div>
      </form>
    </>
  )
}
